import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { combineReducers, entityMetaReducer } from '@core/utils/state';
import { initialEmployeesState } from './employees-state';
import { EmployeesEffects } from './employees-effects';
import { reducer } from './employees-reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.EMPLOYEES, (reducer as ActionReducer<any, any>), {
            initialState: initialEmployeesState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ EmployeesEffects ])
    ],
    declarations: []
})
export class EmployeesStateModule {}
